import WorkDetails from './WorkDetails';

export default WorkDetails;
